import { DEFAULT_NOTE_TYPES, NOTE_STATUS } from "@/services/api";
import { NoteDirection } from "@/shared/Components";
import type { Note } from "@/services/api";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  record: {
    status: Note["status"];
    noteType: Note["noteType"];
    direction: Note["direction"];
  };
};

export const DirectionIcon: FC<Props> = ({ record }) => {
  return (
    <div className={styles.wrapper}>
      <NoteDirection
        disabled={
          record.status === NOTE_STATUS.DONE &&
          record.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT
        }
        direction={record.direction}
      />
    </div>
  );
};
